export enum FrequencyOption {
  once = 'once',
  monthly = 'monthly',
  yearly = 'yearly',
}

export const FREQUENCY_OPTIONS: Readonly<{ value: string; label: string; disabled?: boolean }>[] = [
  { value: '', label: 'Select frequency…', disabled: true },
  { value: FrequencyOption.once, label: 'Only once, on this date' },
  { value: FrequencyOption.monthly, label: 'Every month' },
  { value: FrequencyOption.yearly, label: 'Every year' },
];

export enum LeadDaysType {
  on = 'on',
  before = 'before',
  after = 'after',
}

export const LEAD_DAYS_TYPES: Readonly<{ value: string; label: string; disabled?: boolean }>[] = [
  { value: LeadDaysType.on, label: 'on' },
  { value: LeadDaysType.after, label: 'after' },
  { value: LeadDaysType.before, label: 'before' },
];
